import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
interface LatencyRow {
  label: string;
  value: string;
  fill: number;
  muted?: boolean;
}
const rows: LatencyRow[] = [{
  label: 'Call pickup',
  value: 'live',
  fill: 8
}, {
  label: 'Form reply',
  value: '0:47',
  fill: 22
}, {
  label: 'Portal lead text',
  value: '0:52',
  fill: 26
}, {
  label: 'Polled automation',
  value: '12:00+ (we never use these)',
  fill: 100,
  muted: true
}];
export function LatencyVignette() {
  const reduceMotion = useReducedMotion();
  return <VignetteFrame label="Capture to first response" timestamp="Demonstrative" data-id="element-357" data-mp="3n5akphdq8r6p">
      <ul className="space-y-5" data-id="element-358" data-mp="3ibg44mtf4sbu">
        {rows.map((row, index) => <li key={row.label} data-id="element-359" data-mp="2um510yoliluj" data-mpi={index}>
            <Reveal delay={0.08 * index} offset={10} data-id="element-360" data-mp="2ul27sk3sw7bg">
              <div className="flex items-center justify-between gap-4" data-id="element-361" data-mp="2povb7hxao866">
                <div className="flex items-center gap-2" data-id="element-362" data-mp="2es0kb3obi2qq">
                  {row.muted ? <MinusIcon className="h-3.5 w-3.5 text-white/25" aria-hidden="true" data-id="element-363" data-mp="2itcd1i2hn435" /> : <CheckIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-364" data-mp="2njkdlaa6rkeb" />}
                  <span className={`text-sm font-medium ${row.muted ? 'text-white/35' : 'text-white/80'}`} data-id="element-365" data-mp="2sjoyrdm1h3av">
                    {row.label}
                  </span>
                </div>
                <span className={`text-xs font-semibold tabular-nums ${row.muted ? 'text-white/30' : 'text-brand'}`} data-id="element-366" data-mp="1zwb3rl1wihte">
                  {row.value}
                </span>
              </div>
              <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-white/[0.06]" data-id="element-367" data-mp="3g882dfu58rwm">
                <motion.div className={`h-full rounded-full ${row.muted ? 'bg-white/15' : 'bg-brand'}`} style={{
              willChange: 'transform',
              originX: 0
            }} initial={reduceMotion ? {
              scaleX: row.fill / 100
            } : {
              scaleX: 0
            }} whileInView={{
              scaleX: row.fill / 100
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.7,
              delay: reduceMotion ? 0 : 0.15 + index * 0.12,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-368" data-mp="3l69lu1vhet8m" />
              </div>
            </Reveal>
          </li>)}
      </ul>
      <p className="mt-6 border-t border-white/10 pt-4 text-xs leading-relaxed text-white/40" data-id="element-369" data-mp="2ml3ojgks4d0d">
        Measured per source during onboarding. Anything that waits on a poll or an inbox
        sync never makes the cut.
      </p>
    </VignetteFrame>;
}